import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import TablePagination from '@material-ui/core/TablePagination'
import { referencesActions, confirmActions, messageActions } from '../../actions'
import jwt_decode from 'jwt-decode'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import { reloadTable } from '../../utils/reloadTable'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchReferences, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchReferences({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchReferences } = this.props
    fetchReferences()
  }

  renderActions = item => {
    const { fetchReference, deleteReference, addConfirm, token, restoreReference } = this.props

    return (
      <Fragment>
        {readOnly('referencias', token) &&
          !item.deletedAt && (
            <IconButton
              onClick={() => {
                fetchReference(item._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!item.deletedAt && findPermission('referencias', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração desta referência?',
                confirmFunction: () => {
                  restoreReference(item._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('referencias', token).editar && (
              <IconButton
                onClick={() => {
                  fetchReference(item._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('referencias', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão desta referência?',
                    confirmFunction: () => {
                      deleteReference(item._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  handleChangePage = (event, page) => {
    const { handleChangePage } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { handleChangePerPage } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection, pagination } = this.props

    const { page, rowsPerPage: perPage } = pagination

    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  render() {
    const {
      classes,
      references = [],
      loadingReferences,
      addConfirm,
      restoreReference,
      pagination,
      order = {}
    } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingReferences && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          width={'990px'}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'descricao'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('descricao')
                  }}
                >
                  Referência
                </TableSortLabel>
              </TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false} className={classes.tableBody}>
            {(references || []).length ? (
              (references || []).map(content => {
                return (
                  <TableRow key={content._id}>
                    <TableRowColumn>
                      {(content.descricao || {}).replace(/(&nbsp;|<([^>]+)>)/gi, '')}
                    </TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(content)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingReferences ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    reference: state.references.reference,
    references: state.references.references,
    loadingReferences: state.references.loadingReferences,
    token: state.auth.token,
    pagination: state.references.referencesPagination,
    order: state.references.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(referencesActions.openModal())
    },
    closeModal: () => {
      dispatch(referencesActions.closeModal())
    },
    fetchReference: id => {
      dispatch(referencesActions.fetchReference(id))
    },
    fetchReferences: options => {
      dispatch(referencesActions.fetchReferences(options))
    },
    deleteReference: id => {
      dispatch(referencesActions.deleteReference(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    restoreReference: id => {
      dispatch(referencesActions.restoreReference(id))
    },
    handleChangePage: page => {
      dispatch(referencesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(referencesActions.handleChangePerPage(perPage))
    },
    changeOrderColumn: column => {
      dispatch(referencesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(referencesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/References/ListTable.js